(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tortuga-cart"]) return;
  try {
    
/**
 * Tortuga cart — qty +/− buttons, debounced form submission.
 * Native cart form does the actual update; buttons just nudge the input
 * and submit. The discount field is a placeholder — codes apply at checkout.
 *
 * Wholesale customers don't have the discount input rendered, so the
 * applyBtn lookup will return null and the handler safely skips wiring.
 *
 * bindCart() wires everything inside the current #cart-form. It runs once on
 * load and again after a one-tap add-on re-renders the section (the old DOM,
 * and its listeners, are replaced wholesale).
 */
(function () {
  let form;
  let submitTimer = null;

  function scheduleSubmit() {
    clearTimeout(submitTimer);
    submitTimer = setTimeout(function () {
      submitTimer = null;
      form.submit();
    }, 600);
  }

  function bindCart() {
  form = document.getElementById('cart-form');
  if (!form) return;

  // +/- buttons
  form.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.getAttribute('data-line-key');
      const delta = parseInt(btn.getAttribute('data-qty-change'), 10);
      const input = form.querySelector('input[name="updates[' + key + ']"]');
      if (!input) return;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;
      scheduleSubmit();
    });
  });

  // Manual edits
  form.querySelectorAll('input[name^="updates["]').forEach(function (input) {
    input.addEventListener('change', scheduleSubmit);
  });

  // Discount field — placeholder behavior (real apply happens at checkout).
  // Wholesale customers don't have this field rendered; the null check skips wiring.
  const applyBtn = form.querySelector('[data-discount-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      const input = form.querySelector('input[name="discount"]');
      if (input && input.value.trim()) {
        applyBtn.textContent = 'Apply at checkout';
        applyBtn.disabled = true;
      }
    });
  }

  bindAddons();
  }

  // ── One-tap add-ons ────────────────────────────────────────────
  // POST /cart/add.js with the hidden _source property, asking Shopify to
  // render this section + the header cart bubble in the same response
  // (bundled Section Rendering). Swap them in, re-bind, announce.
  function announce(message) {
    let region = document.getElementById('tuga-cart-live');
    if (!region) {
      region = document.createElement('div');
      region.id = 'tuga-cart-live';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 100);
  }

  function parseSection(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function bindAddons() {
    const root = form.querySelector('[data-tuga-addons]');
    if (!root) return;
    const sectionEl = form.closest('.tortuga-cart');
    const sectionId = sectionEl && sectionEl.getAttribute('data-section-id');
    const addUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';

    root.querySelectorAll('[data-tuga-addon]').forEach(function (card) {
      const btn = card.querySelector('[data-tuga-addon-add]');
      const select = card.querySelector('[data-tuga-addon-variant]');
      const priceEl = card.querySelector('[data-tuga-addon-price]');
      const errorEl = card.querySelector('[data-tuga-addon-error]');
      if (!btn) return;

      if (select && priceEl) {
        select.addEventListener('change', function () {
          const opt = select.options[select.selectedIndex];
          if (opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
        });
      }

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        const variantId = parseInt(select ? select.value : btn.getAttribute('data-variant-id'), 10);
        const title = card.getAttribute('data-product-title') || 'Item';
        const label = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        const sections = ['cart-icon-bubble'];
        if (sectionId) sections.unshift(sectionId);

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { _source: 'cart-addon' } }],
            sections: sections,
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              // Shopify's 422 body carries a customer-safe description
              // (e.g. "All 3 Diamond Sharpening File are in your cart.").
              throw { userMessage: result.data && (result.data.description || result.data.message) };
            }

            // A qty change was mid-debounce: let the native submit run now.
            // It re-renders /cart server-side, new add-on line included.
            if (submitTimer) {
              clearTimeout(submitTimer);
              submitTimer = null;
              form.submit();
              return;
            }

            const rendered = result.data.sections || {};
            const fresh = sectionId && rendered[sectionId] && parseSection(rendered[sectionId], '.tortuga-cart');
            if (!fresh) {
              window.location.assign(window.location.pathname);
              return;
            }

            const bubble = document.getElementById('cart-icon-bubble');
            const bubbleFresh = rendered['cart-icon-bubble'] && parseSection(rendered['cart-icon-bubble'], '.shopify-section');
            if (bubble && bubbleFresh) bubble.innerHTML = bubbleFresh.innerHTML;

            sectionEl.replaceWith(fresh);
            bindCart();

            const addedKey = result.data.items && result.data.items[0] && result.data.items[0].key;
            const addedTitle = addedKey && document.querySelector('.tortuga-cart .item[data-line-key="' + addedKey + '"] .item-title');
            if (addedTitle) addedTitle.focus();
            announce(title + ' added to your cart.');
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = label;
            if (errorEl) {
              errorEl.textContent = (err && err.userMessage) || "Couldn't add that. Please try again.";
              errorEl.hidden = false;
            }
          });
      });
    });
  }

  bindCart();
})();

  } catch(e) { console.error(e); }
})();
})();
